import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const Info = styled(Typography)`
  display: inline-block;
`

export default Info
